import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import './home.css';
import './NewPage.css';
import {
    fetchHeaderSearch, storeRequestCallback, fetchAllDoctors, fetchAllSpecialities,
    fetchFilterOPD
} from "../Adapter/PageAdapter";
import { fetchHomeHeaderNumbers } from "../Adapter/HomePageAdapter";
import { baseImage_path } from "../variables/Variables";
import { Toaster, toast } from 'sonner';
import logo from '../assets/images/raheja-logo.png';
import logoSvg from '../assets/images/slraheja-logo-svg.svg';
import flogo from '../assets/images/footer-logo.svg';
import yt from '../assets/images/ythead.svg';
import fb from '../assets/images/fbhead.svg';
import linked from '../assets/images/linkednhead.svg';
import inst from '../assets/images/instaicnhead.svg';
import call from '../assets/images/headphn.svg';
import healthChkupIcn from '../assets/images/healthchkupfoot.svg';
import searchIcon from '../assets/images/searcheadicn.svg';
import stickyFootCallIcon from '../assets/images/sticky-foot-call.svg';
import doctorStickyIcon from '../assets/images/sticky-foot-doctor.svg';
import menuIcon from '../assets/images/menu.png';
import closeIcon from '../assets/images/closethick.png';
import newArrImg from "../assets/images/arrw.svg";

const MOB_HEADER_QUICK_CALL_NUMBER = "02268846141";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isManuallyOpened, setIsManuallyOpened] = useState(false);
    const [specialties, setSpecialties] = useState([]);
    const [doctorsList, setDoctorsList] = useState([]);
    const [headerNumbers, setHeaderNumbers] = useState({
        domestic_number: "",
        international_number: "",
        emergency_number: "",
    });
    const [loading, setLoading] = useState(false);
    const searchRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [openDropdown, setOpenDropdown] = useState(null);
    const [suppressHover, setSuppressHover] = useState(false);

    const toggleDropdown = (name) => {
        setOpenDropdown((prev) => (prev === name ? null : name));
    };

    useEffect(() => {
        const getHeaderNumbers = async () => {
            try {
                const response = await fetchHomeHeaderNumbers();
                if (response?.data) {
                    setHeaderNumbers({
                        domestic_number: response.data.domestic_number || "",
                        international_number: response.data.international_number || "",
                        emergency_number: response.data.emergency_number || ""
                    });
                }
            } catch (error) {
                console.error("Failed to load header contact numbers:", error);
            }
        };

        getHeaderNumbers();
    }, []);

    // Define phone numbers
    // const defaultPhoneNumber = "022-68846141";
    // const internationalPhoneNumber = "+917304509351";

    // const defaultEmergencyNumber = "022-66529979";
    // const internationalEmergencyNumber = "022-66529979";

    const isInternationalPage = location.pathname === "/international-patients";

    const phoneNumber = isInternationalPage
        ? headerNumbers.international_number
        : headerNumbers.domestic_number;

    const emergencyNumber = isInternationalPage
        ? headerNumbers.emergency_number
        : headerNumbers.emergency_number;

    // const phoneNumber = isInternationalPage ? internationalPhoneNumber : defaultPhoneNumber;
    // const emergencyNumber = isInternationalPage ? internationalEmergencyNumber : defaultEmergencyNumber;

    // Toggle mobile menu

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const hidemenu = () => {
        setIsMenuOpen(false)
    }

    const toggleSearch = (e) => {
        e.stopPropagation(); // Prevent click event from bubbling to the document
        setIsSearchOpen(!isSearchOpen);
        setSearchQuery("");
        setSearchResults([]);
    };

    // Fetch doctors when a specialty is selected
    const handleSpecialtyList = async (e) => {
        const specialityId = e.target.value;
        setFormData({
            ...formData,
            speciality_id: specialityId,
            doctor_id: "",
        });

        try {
            const response = await fetchFilterOPD(specialityId);
            if (response && response.data) {
                setDoctorsList(response.data);
            } else {
                setDoctorsList([]);
            }
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    };

    useEffect(() => {
        const fetchSpecialties = async () => {
            try {
                const response = await fetchAllSpecialities();
                if (response && response.specialities) {
                    setSpecialties(response.specialities);
                }
            } catch (error) {
                console.error("Error fetching specialties:", error);
            }
        };
        fetchSpecialties();
    }, []);

    const handleSearchChange = async (e) => {
        const query = e.target.value;
        setSearchQuery(query);

        if (query.length > 2) {
            try {
                const response = await fetchHeaderSearch(query);
                if (response && response.data) {
                    const results = [];
                    const resultsData = response.data.results || response.data;
                    const opdSchedules = response.data.opd_schedules || [];

                    const doctors = resultsData.doctors || [];
                    results.push(...doctors.map((doc) => {
                        const opdSchedule = opdSchedules.find(schedule => schedule.doctor_id === doc.id);
                        const specialtyName = opdSchedule ? opdSchedule.specialty_name : "No Specialty";

                        return {
                            type: "doctor",
                            id: doc.id,
                            slug: doc.slug,
                            name: `${doc.name} - ${specialtyName}`,
                            img: doc.img_path || "default.jpg",
                        };
                    }));

                    // Handling specialties
                    const specialties = resultsData.specialties || [];
                    results.push(...specialties.map((spec) => ({
                        type: "speciality",
                        id: spec.id,
                        slug: spec.slug,
                        name: spec.name,
                        img: spec.img_path || "default.jpg",
                    })));

                    setSearchResults(results);
                } else {
                    setSearchResults([]);
                }
            } catch (error) {
                console.error("Search Error:", error);
                setSearchResults([]);
            }
        } else {
            setSearchResults([]);
        }
    };

    const handleSelectResult = (result) => {
        setIsSearchOpen(false);
        setTimeout(() => {
            if (result.type === "doctor") {
                if (result.slug) {
                    navigate(`/doctor/${result.slug}`);
                } else {
                    navigate(`/doctor/${result.id}`); // Fallback to ID if slug is missing
                }
            } else if (result.type === "speciality") {
                if (result.slug) {
                    navigate(`/specialities/${result.slug}`);
                } else {
                    navigate(`/specialities/${result.id}`); // Fallback to ID if slug is missing
                }
            }
        }, 0);
    };

    const [formData, setFormData] = useState({
        patientName: "",
        contact_number: "",
        email: "",
        message: "",
        appointment_date: "",
        doctor_id: "",
        doctor_name: "",
        speciality_id: "",
        speciality_name: "",
    });

    // const handleInputChange = (event) => {
    //     setFormData({
    //         ...formData,
    //         [event.target.name]: event.target.value,
    //     });
    // };
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // Only allow numbers and plus in contactNo
        if (name === "contactNo" || name === "countryCode") {
            const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
            setFormData({ ...formData, [name]: sanitizedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

	useEffect(() => {
        setOpenDropdown(null);
        setSuppressHover(false);
    }, [location.pathname]);

    const handleOpenModal = () => {
        setShowModal(true);
        setIsManuallyOpened(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);

        // Manually remove Bootstrap modal-related classes
        document.body.classList.remove("modal-open");

        // Remove the modal backdrop if it exists
        const modalBackdrops = document.getElementsByClassName("modal-backdrop");
        while (modalBackdrops.length > 0) {
            modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
        }
    };

    useEffect(() => {
        if (!isManuallyOpened) {  // Only trigger the timer if not manually opened
            const timer = setTimeout(() => {
                setShowModal(true);
            }, 15000000);

            return () => clearTimeout(timer); // Cleanup timer on component unmount
        }
    }, [isManuallyOpened]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (loading) return;

        setLoading(true);

        const selectedDoctor = doctorsList.find(
            (doc) => parseInt(doc.doctor_id) === parseInt(formData.doctor_id)
        );
        const selectedSpeciality = specialties.find(
            (spec) => parseInt(spec.id) === parseInt(formData.speciality_id)
        );

        const payload = {
            patient_name: formData.patientName,
            contact_number: formData.contactNo,
            email: formData.email,
            message: formData.message,
            appointment_date: formData.date,
            speciality_id: formData.speciality_id,
            doctor_id: formData.doctor_id,
            doctor_name: selectedDoctor?.doctor_name || "",
            speciality_name: selectedSpeciality?.name || "",
        };

        const crmPayload = {
            first_name: payload.patient_name?.split(" ")[0],
            last_name: payload.patient_name?.split(" ")[1] || "",
            phone: payload.contact_number,
            email: payload.email,
            message: payload.message,
            leadsource: "Doctor Appointment Form Homepage",
            fortis_doctor_name: payload.doctor_name,
            referred_for_specilaity: payload.speciality_name,
            expected_admission_date: payload.appointment_date,
        };

        try {
            const result = await storeRequestCallback(payload);

            console.log("Full submission result:", result); // ⬅️ Add this

            const backendOk = result?.backendResult?.message?.toLowerCase().includes("success");
            const crmOk = result?.crmResult?.status === "success";

            if (backendOk && crmOk) {
                toast.success("Request submitted successfully!");
            } else {
                toast.success("Request submitted successfully!");
            }

            setFormData({
                patientName: "",
                contactNo: "",
                email: "",
                speciality_id: "",
                doctor_id: "",
                date: "",
                message: "",
            });
            setDoctorsList([]);
            handleCloseModal();

        } catch (error) {
            console.error("Submission error:", error);
            toast.error("An error occurred. Please try again.");
        }
        finally {
            setLoading(false);
        }
    };

    const handleDoctorSpecialityClick = (slug) => {
        navigate("/doctor", { state: { selectedSpecialty: slug } });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isSearchIcon = event.target.closest('.search-icon');
            if (!isSearchIcon && searchRef.current && !searchRef.current.contains(event.target)) {
                setIsSearchOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            <header id="header">
                <div className="desk-head">
                    <div className="tophead">
                        <div className="cust-container">
                            <div className="head flex">
                                <div className="logo">
                                    <NavLink to="/"><img src={logoSvg} alt="logo" /></NavLink>
                                </div>
                                <div className="contact-details flex">
                                    <div className="social-links flex">
                                        <a href="https://www.facebook.com/SLRahejahospitalFortisAssociate/" target="_blank"><img src={fb} alt="facebook" /></a>
                                        <a href="https://www.instagram.com/slraheja_hospital/" target="_blank"><img src={inst} alt="instagram" /></a>
                                        <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fs.l.rahejahospital%2Fabout" target="_blank"><img src={linked} alt="linkedin" /></a>
                                        <a href="https://www.youtube.com/@FortisHospitalsMumbai" target="_blank"><img src={yt} alt="youtube" /></a>
                                    </div>
                                    <div className="phone-details flex">
                                        {/* <a href="tel:+9102268846141">
                                            <img className="phone-num" src={call} alt="phone" />+9102268846141
                                        </a>
                                        <span>|</span>
                                        <span>Emergency</span>
                                        <a href="tel:+91022-66529979" className="phlstchld">022-66529979</a> */}
                                        <div className="phone-details flex">
                                            <a href={`tel:${phoneNumber}`}>
                                                <img className="phone-num" src={call} alt="phone" />
                                                {phoneNumber}
                                            </a>
                                            <span>|</span>
                                            <span>Emergency</span>
                                            <a href={`tel:${emergencyNumber}`} className="phlstchld">{emergencyNumber}</a>
                                        </div>
                                        <div className="search-icon" onClick={toggleSearch}>
                                            <a href="#"><img src={searchIcon} alt="search" /></a>
                                        </div>
                                    </div>
                                    <div className="information flex">
                                        <a href="#" onClick={handleOpenModal} className="btn with-color active">Book Appointment</a>
                                        <NavLink to="/opd-schedule" className="btn without-color">OPD Schedule</NavLink>
                                        <NavLink to="/take-a-tour" className="btn without-color">Take a Tour</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <nav className="navbar menu deskmenubar" id="navbar">
                        <div className="cust-container">
                            <ul className="nav-links flex">
                                <li><NavLink to="/">Home</NavLink></li>
                                <li><NavLink to="/about-us">About Us</NavLink></li>

                                {/* <li><NavLink to="/specialities">Specialities</NavLink></li> */}
	    {/*  <li className="dropdown specialties-dropdown">  */}
	                            <li
                                    className={`dropdown specialties-dropdown ${suppressHover ? 'no-hover' : ''}`}
                                >
                                    <NavLink to="/specialities" style={{ padding: '0.6rem 0rem' }}>Specialities
                                        <span className="dropdown-icon" />
                                    </NavLink>
                                    <div className="dropdown-menu custom-specialties-dropdown">
                                        <div className="specialties-grid">
                                            {[
                                                { name: "Audiology", slug: "audiology" },
                                                { name: "Bariatric Surgery", slug: "bariatric-surgery" },
                                                {
                                                    name: "Cardiac Sciences",
                                                    slug: "cardiac-sciences",
                                                    children: [
                                                        { name: "Cardio-Vascular Thoracic Surgery", slug: "cardio-vascular-thoracic-surgery-cvts" },
                                                        { name: "Interventional Cardiology", slug: "interventional-cardiology" },
                                                        { name: "Non-Invasive Cardiology", slug: "non-invasive-cardiology" },
                                                        { name: "Paediatric Cardiology", slug: "paediatric-cardiology" },
                                                        { name: "Structural Heart (TAVI / TAVR)", slug: "structural-heart" },
                                                    ]
                                                },
                                                {
                                                    name: "Critical Care",
                                                    slug: "emergency-medicines-critical-care",
                                                    children: [
                                                        { name: "Emergency Medicine", slug: "emergency-medicines-critical-care" }
                                                    ]
                                                },
                                                { name: "Dentistry", slug: "dentistry" },
                                                { name: "Dermatology", slug: "dermatology" },
                                                {
                                                    name: "Diabetes",
                                                    slug: "diabetology",
                                                    children: [
                                                        { name: "Diabetology", slug: "diabetology" },
                                                        { name: "Diabetic Foot Surgery", slug: "diabetic-foot-surgery" },
                                                        { name: "Interventional Radiology", slug: "interventional-radiology" }
                                                    ]
                                                },
                                                { name: "Dietetics & Nutrition", slug: "dietetics-nutrition" },
                                                {
                                                    name: "Endocrinology",
                                                    slug: "endocrinology",
                                                    children: [
                                                        { name: "Endocrine Surgery", slug: "endocrine-surgery" },
                                                    ]
                                                },
                                                { name: "ENT", slug: "ent" },
                                                {
                                                    name: "Gastro-Intestinal Science",
                                                    slug: "gastro-intestinal-science",
                                                    children: [
                                                        { name: "Gastroenterology", slug: "gastroenterology" },
                                                        { name: "Paediatric Gastroenterology", slug: "paediatric-gastroenterology" },
                                                        { name: "Hepatology", slug: "hepatology" },
                                                        { name: "General & Laparoscopic Surgery", slug: "general-laparoscopic-surgery" },
                                                        { name: "Colorectal Surgery", slug: "colorectal-surgery" },
                                                        { name: "HPB Surgery & Liver Transplant", slug: "hpb-surgery-liver-transplant" }
                                                    ]
                                                },
                                                { name: "Infectious Diseases", slug: "infectious-diseases" },
                                                { name: "Internal Medicine", slug: "internal-medicine" },
                                                {
                                                    name: "Imaging & Diagnostics",
                                                    slug: "imaging-diagnostics",
                                                    children: [
                                                        { name: "Pathology", slug: "radiology-pathology" },
                                                        { name: "Histopathology", slug: "histopathology" },
                                                        { name: "Radiology", slug: "radiology-pathology" },
                                                        { name: "Executive Health Check-up", slug: "executive-health-check-up" },
                                                        { name: "Non-Invasive Cardiology", slug: "non-invasive-cardiology" }
                                                    ]
                                                },
                                                {
                                                    name: "Mental Health",
                                                    slug: "mental-health",
                                                    children: [
                                                        { name: "Clinical Psychology", slug: "clinical-psychology" },
                                                        { name: "Psychiatry", slug: "psychiatry" }
                                                    ]
                                                },
                                                {
                                                    name: "Nephrology",
                                                    slug: "Nephrology",
                                                    children: [
                                                        { name: "Dialysis Care", slug: "dialysis-care" },
                                                        { name: "Kidney Transplant", slug: "kidney-transplant" }
                                                    ]
                                                },
                                                {
                                                    name: "Neuro-Science",
                                                    slug: "neuro-science",
                                                    children: [
                                                        { name: "Neurology", slug: "neurology" },
                                                        { name: "Neuro-Surgery", slug: "neuro-surgery" },
                                                        { name: "Interventional Neurology", slug: "interventional-neurology" }
                                                    ]
                                                },
                                                { name: "Nuclear Medicine", slug: "nuclear-medicine" },
                                                {
                                                    name: "Oral & Maxillofacial Surgery",
                                                    slug: "oral-maxillofacial-surgery",
                                                    children: [
                                                        { name: "Oral, Maxillofacial & Reconstructive Surgery", slug: "oral-maxillofacial-reconstructive-surgery" },
                                                        { name: "Cleft Lip/Palate (Paediatric)", slug: "cleft-lip-palate-paediatric" }
                                                    ]
                                                },
                                                {
                                                    name: "Oncology",
                                                    slug: "oncology",
                                                    children: [
                                                        { name: "Bone Marrow Transplant", slug: "bone-marrow-transplant" },
                                                        { name: "Haematology", slug: "haematology" },
                                                        { name: "Medical Oncology", slug: "medical-oncology" },
                                                       // { name: "Organ Specific content", slug: "organ-specific-content" },
                                                        { name: "Surgical Oncology", slug: "surgical-oncology" }
                                                    ]
                                                },
                                                {
                                                    name: "Obstetrics & Gynaecology",
                                                    slug: "obstetrics-gynaecology",
                                                    children: [
                                                        { name: "Maternity Care", slug: "maternity-care" },
                                                        { name: "Gynaec-Surgery", slug: "gynaec-surgery" },
                                                        { name: "Onco-Gynaecology", slug: "onco-gynaecology" },
                                                        { name: "Uro-Gynaecology", slug: "uro-gynaecology" }
                                                    ]
                                                },
                                                {
                                                    name: "Orthopaedics",
                                                    slug: "orthopaedics",
                                                    children: [
                                                        { name: "Arthroscopy", slug: "arthroscopy" },
                                                        { name: "General Orthopaedics & Trauma", slug: "general-orthopaedics" },
                                                        { name: "Joint Replacement", slug: "joint-replacement" },
                                                        { name: "Paediatric Orthopaedics", slug: "paediatric-orthopaedics" },
                                                        { name: "Spine Surgery", slug: "spine-surgery" },
                                                        { name: "Sports Medicine", slug: "sports-medicine" },
                                                    ]
                                                },
                                                { name: "Organ Transplant", slug: "organ-transplant" },
                                                {
                                                    name: "Paediatrics",
                                                    slug: "paediatrics",
                                                    children: [
                                                        { name: "General Paediatrics", slug: "general-paediatrics" },
                                                        { name: "Neonatology", slug: "neonatology" },
                                                        { name: "Paediatric Surgery", slug: "paediatric-surgery" },
                                                        { name: "Paediatric Cardiology", slug: "paediatric-cardiology" },
                                                        { name: "Paediatric Orthopaedics", slug: "paediatric-orthopaedics" },
                                                        { name: "Paediatric Gastroenterology", slug: "paediatric-gastroenterology" },
                                                        { name: "Paediatric Pulmonology", slug: "paediatric-pulmonology" },
                                                        { name: "Paediatric Endocrinology", slug: "paediatric-endocrinology" },
                                                        { name: "Paediatric Neurology", slug: "paediatric-neurology" },
                                                        { name: "Paediatric Ophthalmology", slug: "paediatric-ophthalmology" },
                                                        { name: "Vaccinations", slug: "vaccinations" }
                                                    ]
                                                },
                                                {
                                                    name: "Pain Management",
                                                    slug: "pain-management",
                                                    children: [
                                                        { name: "Anesthesiology", slug: "anesthesiology" }
                                                    ]
                                                },
                                                { name: "Physiotherapy & Rehabilitation", slug: "physiotherapy-rehabilitation" },
                                               // { name: "Plastic Surgery", slug: "plastic-surgery" },
                                                { name: "Plastic & Reconstructive Surgery", slug: "plastic-reconstructive-surgery" },
                                                { name: "Pulmonology / Chest Medicine", slug: "pulmonology-chest-medicine" },
                                                { name: "Rheumatology", slug: "rheumatology" },
                                                {
                                                    name: "Transfusion Medicine",
                                                    slug: "transfusion-medicine",
                                                    children: [
                                                        { name: "Blood Bank", slug: "blood-bank" },
                                                        { name: "Thalassemia", slug: "thalassemia" }
                                                    ]
                                                },
                                                {
                                                    name: "Urology",
                                                    slug: "urology",
                                                    children: [
                                                        { name: "Andrology", slug: "andrology" },
                                                        { name: "Urology", slug: "urology" },
                                                        { name: "Uro-Oncology", slug: "uro-oncology" }
                                                    ]
                                                },
                                                {
                                                    name: "Vascular Surgery",
                                                    slug: "vascular-surgery",
                                                    children: [
                                                        { name: "Vascular, Endo-Vascular & Laser Surgery", slug: "vascular-endo-vascular-laser-surgery" },
                                                        { name: "Interventional Radiology", slug: "interventional-radiology" }
                                                    ]
                                                },
                                            ].map((item, idx) => {
                                                const hasChildren = item.children?.length > 0;
                                                const showArrow = ["Endocrinology", "Mental Health", "Nephrology", "Paediatrics",
                                                    "Gastro-Intestinal Science", "Orthopaedics", "Obstetrics & Gynaecology", "Imaging & Diagnostics",
                                                    "Oncology", "Cardiac Sciences", "Urology", "Neuro-Science", "Diabetes", "Vascular Surgery",
                                                    "Transfusion Medicine", "Oral & Maxillofacial Surgery", "Pain Management", "Critical Care"
                                                ].includes(item.name);
                                                const isOpen = openDropdown === item.name;

                                                return (
                                                    <div className={`specialty-block ${hasChildren ? "has-children" : ""}`} key={idx}>
                                                        <div
                                                            className="main-link-wrapper"
                                                            style={{ cursor: showArrow ? "pointer" : "default" }}
                                                            onClick={() => showArrow && toggleDropdown(item.name)}
                                                        >
                                                            <NavLink className="main-link" to={`/specialities/${item.slug}`}
                                                            // on Click={() => {
                                                            //                    setSuppressHover(true);
                                                            //                    setTimeout(() => setSuppressHover(false), 500); // allow hover again after 500ms
                                                            //                }} 
							>
                                                                {item.name}
                                                            </NavLink>

                                                            {showArrow && (
                                                                <span
                                                                    className={`dropdown-arrow-icon ${isOpen ? "open" : ""}`}
                                                                >
                                                                    &#8250;
                                                                </span>
                                                            )}
                                                        </div>

                                                        {hasChildren && (!showArrow || isOpen) && (
                                                            <ul className="sub-specialties-list">
                                                                {item.children.map((sub, i) => (
                                                                    <li key={i}>
                                                                        <NavLink to={`/specialities/${sub.slug}`}
                                                                        onClick={() => {
                                                                                setSuppressHover(true);
                                                                                setTimeout(() => setSuppressHover(false), 500); // allow hover again after 500ms
                                                                            }}
									>{sub.name}</NavLink>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}

                                                        <div className="divider-line" />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </li>

                                <li><NavLink to="/doctor">Doctors</NavLink></li>
                                {/* <li className="dropdown specialties-dropdown">
                                    <NavLink to="/doctor" style={{ padding: '0.6rem 0rem' }}>Doctors
                                        <span className="dropdown-icon" />
                                    </NavLink>
                                    <div className="dropdown-menu custom-specialties-dropdown dr-dropdown">
                                        <div className="specialties-grid">
                                            {[
                                                { name: "Audiology", slug: "audiology", id: 35 },
                                                { name: "Bariatric Surgery", slug: "bariatric-surgery", id: 25 },
                                                {
                                                    name: "Cardiac Sciences",
                                                    slug: "cardiac-sciences",
                                                    id: 10,
                                                    children: [
                                                        { name: "Cardio-Vascular Thoracic Surgery", slug: "cvts" },
                                                        { name: "Interventional Cardiology", slug: "interventional-cardiology" },
                                                        { name: "Non-Invasive Cardiology", slug: "non-invasive-cardiology", id: 86 },
                                                        { name: "Paediatric Cardiology", slug: "paediatric-cardiology", id: 93 },
                                                        { name: "Structural Heart (TAVI / TAVR)", slug: "structural-heart" },
                                                    ]
                                                },
                                                {
                                                    name: "Critical Care",
                                                    slug: "critical-care",
                                                    id: 9,
                                                    children: [
                                                        { name: "Emergency Medicine", slug: "emergency-medicine", id: 9 }
                                                    ]
                                                },
                                                { name: "Dentistry", slug: "dentistry", id: 5 },
                                                { name: "Dermatology", slug: "Dermatology", id: 24 },
                                                {
                                                    name: "Diabetes",
                                                    slug: "diabetes",
                                                    children: [
                                                        { name: "Diabetology", slug: "diabetology-diabetic-foot-surgery", id: 16 },
                                                        { name: "Diabetic Foot Surgery", slug: "diabetology-diabetic-foot-surgery", id: 100 },
                                                        { name: "Interventional Radiology", slug: "interventional-radiology" }
                                                    ]
                                                },
                                                { name: "Dietetics & Nutrition", slug: "dietetics-nutrition", id: 19 },
                                                {
                                                    name: "Endocrinology",
                                                    slug: "endocrinology",
                                                    id: 13,
                                                    children: [
                                                        { name: "Endocrine Surgery", slug: "endocrine-surgery" },
                                                        { name: "Psychiatry", slug: "psychiatry" }
                                                    ]
                                                },
                                                { name: "ENT", slug: "ent", id: 12 },
                                                {
                                                    name: "Gastro-Intestinal Science",
                                                    slug: "gastro-intestinal-science",
                                                    id: 6,
                                                    children: [
                                                        { name: "Gastroenterology", slug: "gastroenterology" },
                                                        { name: "Paediatric Gastroenterology", slug: "paediatric-gastroenterology", id: 95 },
                                                        { name: "Hepatology", slug: "hepatology" },
                                                        { name: "General & Laparoscopic Surgery", slug: "general-laparoscopic-surgery", id: 104 },
                                                        { name: "Colorectal Surgery", slug: "colorectal-surgery" },
                                                        { name: "HPB Surgery & Liver Transplant", slug: "hpb-surgery-liver-transplant" }
                                                    ]
                                                },
                                                {
                                                    name: "Imaging & Diagnostics",
                                                    slug: "imaging-diagnostics",
                                                    id: 21,
                                                    children: [
                                                        { name: "Pathology", slug: "pathology" },
                                                        { name: "Histopathology", slug: "Histopathology", id: 106 },
                                                        { name: "Radiology", slug: "radiology" },
                                                        { name: "Executive Health Check-up", slug: "executive-health-check-up" },
                                                        { name: "Non-Invasive Cardiology", slug: "non-invasive-cardiology", id: 86 }
                                                    ]
                                                },
                                                {
                                                    name: "Mental Health",
                                                    slug: "mental-health",
                                                    id: 2,
                                                    children: [
                                                        { name: "Clinical Psychology", slug: "clinical-psychology" },
                                                        { name: "Psychiatry", slug: "psychiatry" }
                                                    ]
                                                },
                                                {
                                                    name: "Nephrology",
                                                    slug: "Nephrology",
                                                    id: 26,
                                                    children: [
                                                        { name: "Dialysis Care", slug: "dialysis-care" },
                                                        { name: "Kidney Transplant", slug: "kidney-transplant" }
                                                    ]
                                                },
                                                {
                                                    name: "Neuro-Science",
                                                    slug: "neuro-science",
                                                    id: 15,
                                                    children: [
                                                        { name: "Neurology", slug: "neurology" },
                                                        { name: "Neuro-Surgery", slug: "neuro-surgery" },
                                                        { name: "Interventional Neurology", slug: "interventional-neurology" }
                                                    ]
                                                },
                                                {
                                                    name: "Oral & Maxillofacial Surgery",
                                                    slug: "oral-maxillofacial-surgery",
                                                    id: 30,
                                                    children: [
                                                        { name: "Oral, Maxillofacial & Reconstructive Surgery", slug: "oral-maxillofacial-reconstructive-surgery" },
                                                        { name: "Cleft Lip/Palate (Paediatric)", slug: "cleft-lip-palate-paediatric" }
                                                    ]
                                                },
                                                {
                                                    name: "Oncology",
                                                    slug: "oncology",
                                                    id: 31,
                                                    children: [
                                                        { name: "Bone Marrow Transplant", slug: "bone-marrow-transplant" },
                                                        { name: "Haematology", slug: "haematology", id: 34 },
                                                        { name: "Medical Oncology", slug: "medical-oncology" },
                                                        { name: "Organ Specific content", slug: "organ-specific-content" },
                                                        { name: "Surgical Oncology", slug: "surgical-oncology" }
                                                    ]
                                                },
                                                {
                                                    name: "Obstetrics & Gynaecology",
                                                    slug: "Obstetrics & Gynaecology",
                                                    id: 23,
                                                    children: [
                                                        { name: "Maternity Care", slug: "maternity-care", id: 91 },
                                                        { name: "Gynaec-Surgery", slug: "gynaec-surgery", id: 89 },
                                                        { name: "Onco-Gynaecology", slug: "onco-gynaecology", id: 92 },
                                                        { name: "Uro-Gynaecology", slug: "uro-gynaecology", id: 99 }
                                                    ]
                                                },
                                                {
                                                    name: "Orthopaedics",
                                                    slug: "orthopaedics",
                                                    id: 11,
                                                    children: [
                                                        { name: "Arthroscopy", slug: "arthroscopy" },
                                                        { name: "General Orthopaedics & Trauma", slug: "general-orthopaedics" },
                                                        { name: "Joint Replacement", slug: "joint-replacement" },
                                                        { name: "Paediatric Orthopaedics", slug: "paediatric-orthopaedics", id: 96 },
                                                        { name: "Spine Surgery", slug: "spine-surgery" },
                                                        { name: "Sports Medicine", slug: "sports-medicine" },
                                                    ]
                                                },
                                                { name: "Organ Transplant", slug: "organ-transplant", id: 4 },
                                                {
                                                    name: "Paediatrics",
                                                    slug: "paediatrics",
                                                    id: 3,
                                                    children: [
                                                        { name: "General Paediatrics", slug: "general-paediatrics" },
                                                        { name: "Neonatology", slug: "neonatology" },
                                                        { name: "Paediatric Surgery", slug: "paediatric-surgery", id: 98 },
                                                        { name: "Paediatric Cardiology", slug: "paediatric-cardiology", id: 93 },
                                                        { name: "Paediatric Orthopaedics", slug: "paediatric-orthopaedics", id: 96 },
                                                        { name: "Paediatric Gastroenterology", slug: "paediatric-gastroenterology", id: 95 },
                                                        { name: "Paediatric Pulmonology", slug: "paediatric-pulmonology", id: 97 },
                                                        { name: "Paediatric Endocrinology", slug: "paediatric-endocrinology", id: 94 },
                                                        { name: "Paediatric Neurology", slug: "paediatric-neurology" },
                                                        { name: "Paediatric Ophthalmology", slug: "paediatric-ophthalmology" },
                                                        { name: "Vaccinations", slug: "vaccinations" }
                                                    ]
                                                },
                                                {
                                                    name: "Pain Management",
                                                    slug: "pain-management",
                                                    id: 28,
                                                    children: [
                                                        { name: "Anesthesiology", slug: "anesthesiology" }
                                                    ]
                                                },
                                                { name: "Physiotherapy & Rehabilitation", slug: "physiotherapy-rehabilitation", id: 1 },
                                                { name: "Plastic Surgery", slug: "plastic-surgery" },
                                                { name: "Plastic & Reconstructive Surgery", slug: "plastic-reconstructive-surgery" },
                                                { name: "Pulmonology / Chest Medicine", slug: "pulmonology-chest-medicine", id: 29 },
                                                { name: "Rheumatology", slug: "rheumatology", id: 14 },
                                                {
                                                    name: "Transfusion Medicine",
                                                    slug: "transfusion-medicine",
                                                    id: 20,
                                                    children: [
                                                        { name: "Blood Bank", slug: "blood-bank" },
                                                        { name: "Thalassemia", slug: "thalassemia" }
                                                    ]
                                                },
                                                {
                                                    name: "Urology",
                                                    slug: "urology",
                                                    id: 8,
                                                    children: [
                                                        { name: "Andrology", slug: "andrology", id: 36 },
                                                        { name: "Urology", slug: "urology", id: 8 },
                                                        { name: "Uro-Oncology", slug: "uro-oncology" }
                                                    ]
                                                },
                                                {
                                                    name: "Vascular Surgery",
                                                    slug: "vascular-surgery",
                                                    id: 18,
                                                    children: [
                                                        { name: "Vascular, Endo-Vascular & Laser Surgery", slug: "vascular-endo-vascular-laser-surgery" },
                                                        { name: "Interventional Radiology", slug: "interventional-radiology" }
                                                    ]
                                                },
                                            ].map((item, idx) => {
                                                const hasChildren = item.children?.length > 0;
                                                const showArrow = ["Endocrinology", "Mental Health", "Nephrology", "Paediatrics",
                                                    "Gastro-Intestinal Science", "Orthopaedics", "Obstetrics & Gynaecology", "Imaging & Diagnostics",
                                                    "Oncology", "Cardiac Sciences", "Urology", "Neuro-Science", "Diabetes", "Vascular Surgery",
                                                    "Transfusion Medicine", "Oral & Maxillofacial Surgery", "Pain Management", "Critical Care"
                                                ].includes(item.name);
                                                const isOpen = openDropdown === item.name;

                                                return (
                                                    <div className={`specialty-block ${hasChildren ? "has-children" : ""}`} key={idx}>
                                                        <div
                                                            className="main-link-wrapper"
                                                            style={{ cursor: showArrow ? "pointer" : "default" }}
                                                            onClick={() => showArrow && toggleDropdown(item.name)}
                                                        >
                                                            <NavLink
                                                                className="main-link"
                                                                to="/doctor"
                                                                onClick={() => {
                                                                    window.dispatchEvent(new CustomEvent("speciality-selected", { detail: item.id }));
                                                                }}
                                                            >
                                                                {item.name}
                                                            </NavLink>
                                                            {showArrow && (
                                                                <span
                                                                    className={`dropdown-arrow-icon ${isOpen ? "open" : ""}`}
                                                                >
                                                                    &#8250;
                                                                </span>
                                                            )}
                                                        </div>

                                                        {hasChildren && (!showArrow || isOpen) && (
                                                            <ul className="sub-specialties-list">
                                                                {item.children.map((sub, i) => (
                                                                    <li key={i}>
                                                                        <NavLink
                                                                            to="/doctor"
                                                                            onClick={() => {
                                                                                window.dispatchEvent(new CustomEvent("speciality-selected", { detail: sub.id }));
                                                                            }}
                                                                        >
                                                                            {sub.name}
                                                                        </NavLink>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}

                                                        <div className="divider-line" />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </li> */}

                                <li><NavLink to="/corporate-tpa">Corporate & TPA</NavLink></li>
                                <li><NavLink to="/international-patients">International Patients</NavLink></li>
                                <li><NavLink to="/academics">Academics</NavLink></li>
                                <li><NavLink to="/events">Events</NavLink></li>
                                <li><NavLink to="/blogs">Blogs</NavLink></li>
                                <li><NavLink to="/health-hub" target="_blank" rel="noopener noreferrer">Health Hub</NavLink></li>
                                <li><NavLink to="/career">Career</NavLink></li>
                                <li><NavLink to="/contact-us">Contact Us</NavLink></li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <nav className="navbar navbar-expand-lg mobilenavbar">
                    <div className="mobile-headmain">
                        <div className="mobhead-logo">
                            <a className="navbar-brand custom-brand" href="/"><img className="image-fluid" src={flogo} alt="" title="" /></a>
                        </div>
                        <div className="mobileheaderitems">
                            <a
                                href={`tel:${MOB_HEADER_QUICK_CALL_NUMBER}`}
                                className="mobile-header-call-btn"
                                aria-label="Call S.L. Raheja Hospital"
                            >
                                <PhoneOutlinedIcon className="mobile-header-call-icon" sx={{ color: '#fff' }} aria-hidden />
                            </a>
                            <div className="icon-bars">
                                <button className="navbar-toggler custom-toggler" type="button" onClick={toggleMenu}>
                                    <span id="myImage">
                                        <img className="navbar-toggler-icon" src={isMenuOpen ? closeIcon : menuIcon} alt="Menu" />
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={`navbar-collapse topmrmob ${isMenuOpen ? 'show' : 'collapse'}`} id="navbarNavDropdown" onClick={hidemenu}>
                        <ul className="nav-links">
                            <li><NavLink to="/"><b>Home</b></NavLink></li>
                            <li><NavLink to="/about-us"><b>About Us</b></NavLink></li>
                            <li><NavLink to="/specialities">Specialities</NavLink></li>
                            <li><NavLink to="/doctor">Doctors</NavLink></li>
                            <li><NavLink to="/corporate-tpa">Corporate & TPA</NavLink></li>
                            <li><NavLink to="/international-patients">International Patients</NavLink></li>
                            <li><NavLink to="/academics">Academics</NavLink></li>
                            <li><NavLink to="/events">Events</NavLink></li>
                            <li><NavLink to="/blogs">Blogs</NavLink></li>
                            <li><NavLink to="/health-hub" target="_blank" rel="noopener noreferrer">Health Hub</NavLink></li>
                            <li><NavLink to="/career">Career</NavLink></li>
                            <li><NavLink to="/contact-us">Contact Us</NavLink></li>
                        </ul>
                        <div className="phone-details mobsvgicnwhite">
                            <a href="tel:02268846141">
                                <img className="phone-num" src={call} alt="phone" />022 6884 6141
                            </a>
                            <br />
                            <span>Emergency: <a href="tel:022-66529979" className="phlstchld">022-66529979</a></span>
                        </div>
                        <div className="information">
                            <a href="#" onClick={handleOpenModal} className="btn without-color">Book Appointment</a>
                            <NavLink to="/opd-schedule" className="btn without-color">OPD Schedule</NavLink>
                            <NavLink to="/take-a-tour" className="btn without-color">Take a Tour</NavLink>
                        </div>
                        <div className="social-links">
                            <a href="#"><img src={yt} alt="youtube" /></a>
                            <a href="#"><img src={fb} alt="facebook" /></a>
                            <a href="#"><img src={linked} alt="linkedin" /></a>
                            <a href="#"><img src={inst} alt="instagram" /></a>
                        </div>
                    </div>
                </nav>

                {/* Search Bar */}
                {isSearchOpen && (
                    <div className="search-bar-overlay">
                        <div className="search-bar" ref={searchRef}>
                            <input
                                type="text"
                                placeholder="Search for doctors, specialties, etc..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                            <button className="close-search" onClick={toggleSearch}>✕</button>
                        </div>

                        {/* Search Results Dropdown */}
                        {searchResults.length > 0 ? (
                            <ul className="search-results">
                                {searchResults.map((result) => (
                                    <li key={`${result.type}-${result.id}`} onClick={() => handleSelectResult(result)}>
                                        <img
                                            src={`${baseImage_path}${result.img || "default.jpg"}`}
                                            alt={result.name}
                                            className="search-thumb"
                                        />
                                        <div className="search-info">
                                            <h5>{result.name}</h5>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            searchQuery.length > 2 && <div className="no-results">No results found for "{searchQuery}".</div>
                        )}
                    </div>
                )}
            </header>

            <Toaster position="top-right" />

            {/* Modal for patient form */}
            {showModal && (
                <div
                    className="modal fade custmodal-width custom-modalwdth2 show"
                    style={{ display: "block" }}
                    id="patienform"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modalclosebtn">
                                <button
                                    type="button"
                                    className="close"
                                    onClick={handleCloseModal}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="intern-form-inner">
                                    <h5>Request A Call Back Form:</h5>
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="patientName">
                                                        Full Name of the Patient <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="patientName"
                                                        name="patientName"
                                                        value={formData.patientName}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="contactNo">
                                                        Contact No <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="contactNo"
                                                        name="contactNo"
                                                        value={formData.contactNo}
                                                        onChange={handleInputChange}
                                                        pattern="^\+?[0-9]*$"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="email">Email</label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="speciality">Speciality <span>*</span></label>
                                                    <select
                                                        id="speciality"
                                                        name="speciality"
                                                        value={formData.speciality_id}
                                                        onChange={handleSpecialtyList}
                                                    >
                                                        <option value="">Please select Speciality</option>
                                                        {specialties.map((specialty) => (
                                                            <option key={specialty.id} value={specialty.id}>
                                                                {specialty.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="doctor">Select Doctor <span>*</span></label>
                                                    <select
                                                        id="doctor"
                                                        name="doctor"
                                                        value={formData.doctor_id}
                                                        onChange={(e) => {
                                                            const selectedId = parseInt(e.target.value);
                                                            const selectedDoc = doctorsList.find(doc => parseInt(doc.doctor_id) === selectedId);
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                doctor_id: selectedId,
                                                                doctor_name: selectedDoc?.doctor_name || "",
                                                            }));
                                                        }}                                                    >
                                                        <option value="">Please select Doctor</option>
                                                        {doctorsList.map((doctor) => (
                                                            <option key={doctor.doctor_id} value={doctor.doctor_id}>
                                                                {doctor.doctor_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="date">Please Select Date <span>*</span></label>
                                                    <input
                                                        type="date"
                                                        id="date"
                                                        name="date"
                                                        value={formData.date}
                                                        onChange={handleInputChange}
                                                        min={new Date().toISOString().split("T")[0]}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="message">Message</label>
                                                    <textarea
                                                        id="message"
                                                        name="message"
                                                        value={formData.message}
                                                        onChange={handleInputChange}
                                                        rows="5"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12">
                                                <div className="int-form-item">
                                                    <button type="submit" disabled={loading}>
                                                        {loading ? (
                                                            <>
                                                                <img src={newArrImg} alt="" className="spin" />
                                                                Sending...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <img src={newArrImg} alt="" />
                                                                Submit
                                                            </>
                                                        )}
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Mobile footer sticky */}

            <section className="mobile-sticky-footer">
                <div className="cust-container">
                    <div className="sticky-foot-inner">
                        <ul className="sticky-foot-nav">

                            <li>
                                <NavLink to="/doctor" aria-label="Find doctors">
                                    <span><img className="phone-num" src={doctorStickyIcon} alt="" /></span>
                                    <span className="sticky-foot-label">Doctors</span>
                                </NavLink>
                            </li>
                            <li>
                                <a href="#" onClick={handleOpenModal}>
                                    <span><img className="phone-num" src={call} alt="" /></span>
                                    <span className="sticky-foot-label">Book Appt.</span>
                                </a>
                            </li>
                            <li>
                                <a href="/health-checkup">
                                    <span><img className="phone-num" src={healthChkupIcn} alt="" /></span>
                                    <span className="sticky-foot-label">Health Check Up</span>
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`tel:${MOB_HEADER_QUICK_CALL_NUMBER}`}
                                    aria-label="Call S.L. Raheja Hospital"
                                >
                                    <span><img className="phone-num" src={stickyFootCallIcon} alt="" /></span>
                                    <span className="sticky-foot-label">Call</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Header;
